import { toBooleanFailSafe } from '@blueprint/frontend-basics'

interface AppConfig {
  AUTH_URL: string
  AUTH_REALM: string
  AUTH_CLIENT_ID: string
  BACKEND_URL: string
  DOMAIN_URL: string
  IS_PRODUCTION: string
  APP_ID: string
  BILLING_MODE: string
  BILLING_CLIENT_TOKEN: string
  BILLING_EARLY_ACCESS_PRODUCT_ID: string
  BILLING_SUCCESS_URL: string
  POSTHOG_TOKEN: string
  TRACKING_DISABLED: string
}

const config: AppConfig = (window as any).__CONFIG__ ?? {}

export const appId: string = config.APP_ID ?? ''
export const keycloakURL: string = config.AUTH_URL ?? ''
export const keycloakRealm: string = config.AUTH_REALM ?? ''
export const keycloakClientId: string = config.AUTH_CLIENT_ID ?? ''
export const domainURL: string = config.DOMAIN_URL ?? ''
export const backendURL: string = config.BACKEND_URL ?? ''
export const isProduction: boolean = toBooleanFailSafe(config.IS_PRODUCTION)
export const isTrackingDisabled: boolean = toBooleanFailSafe(config.TRACKING_DISABLED)
export const posthogToken: string | null = config.POSTHOG_TOKEN ?? null
